import { render, staticRenderFns } from "./HandoverBreakdown.vue?vue&type=template&id=241357a2"
import script from "./HandoverBreakdown.vue?vue&type=script&lang=js"
export * from "./HandoverBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports